module.exports = "<p>\n  invoices works!\n</p>\n"